/**
 * Simple Discount Code Copy with Overlay Feedback
 */

function copyDiscountCode(code) {
  // Find the button that was clicked
  const button = event.target;
  
  if (!code) {
    console.error('No discount code provided');
    return;
  }

  // Modern clipboard API with fallback
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(code)
      .then(() => {
        showOverlayFeedback(button, 'Code copied!');
      })
      .catch(() => {
        fallbackCopy(code, button);
      });
  } else {
    fallbackCopy(code, button);
  }
}

// Fallback copy method for older browsers
function fallbackCopy(code, button) {
  const textArea = document.createElement('textarea');
  textArea.value = code;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      showOverlayFeedback(button, 'Code copied!');
    } else {
      showOverlayFeedback(button, 'Copy failed', true);
    }
  } catch (err) {
    console.error('Copy failed:', err);
    showOverlayFeedback(button, 'Copy failed', true);
  }
  
  document.body.removeChild(textArea);
}

// Show overlay feedback directly on the button
function showOverlayFeedback(button, message, isError = false) {
  // Remove any existing overlay
  const existingOverlay = button.querySelector('.discount-code-overlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }
  
  // Create overlay element
  const overlay = document.createElement('div');
  overlay.className = 'discount-code-overlay';
  overlay.textContent = message;
  
  // Add error styling if needed
  if (isError) {
    overlay.style.background = '#ef4444';
    overlay.style.color = 'white';
  }
  
  // Add to button
  button.appendChild(overlay);
  
  // Show overlay
  setTimeout(() => {
    overlay.classList.add('show');
  }, 50);
  
  // Hide and remove overlay
  setTimeout(() => {
    overlay.classList.remove('show');
    setTimeout(() => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }, 300);
  }, 2000);
}